/**
 * ValeoHubilBridge.tsx
 * src/components/Item/
 *
 * Écoute le CustomEvent 'valeo:openHubil' et ouvre HUBIL
 * via addIframeSlide + makeHubidlpURL — mécanisme natif NodeAuto.
 *
 * DOIT être rendu à l'intérieur d'un <SlidesProvider>.
 * Placé dans le bloc PartSelector de CaiaApp.tsx.
 * Retourne null — aucun rendu visuel.
 */
import { useEffect } from 'react';

import { useAuth } from '@/context/AuthContext';
import { VALEO_HUBIL_EVENT } from '@/utils/useValeoProxyListener';
import { makeHubidlpURL } from '@/utils/utils';

import { useAddItemSlide } from './ItemSlides';

export const ValeoHubilBridge = (): null => {
    const { userInfo } = useAuth();
    const { addIframeSlide } = useAddItemSlide();

    useEffect(() => {
        const handler = (e: Event) => {
            const ref = (e as CustomEvent<{ ref: string }>).detail?.ref;
            if (!ref) return;
            if (!userInfo?.userId) return;
            const hubUrl = makeHubidlpURL(userInfo.userId, ref);
            console.log(`[ValeoHubilBridge] ouverture HUBIL → ${hubUrl}`);
            addIframeSlide(hubUrl, true);
        };
        window.addEventListener(VALEO_HUBIL_EVENT, handler);
        return () => window.removeEventListener(VALEO_HUBIL_EVENT, handler);
    }, [userInfo, addIframeSlide]);

    return null;
};
